import type { AppFeatures } from '@/modules/config';

/**
 * Whether topics render through the per-type React component tree
 * (`@/modules/topic_garden`) instead of the legacy monolithic `TopicView`, per
 * the feature flag. Every topic type has been migrated to the component tree, so
 * this single boolean is the whole switch — the dispatch consumers
 * (`{Read,Update,Create}TopicGate`) branch on it directly.
 */
export function topicGardenEnabled(features: AppFeatures): boolean {
  return features.topicGardenEnabled === true;
}
